/* First-party referral transport. This script never calculates commission. */
(() => {
  const script = document.currentScript;
  const endpoint = script?.dataset.endpoint;
  if (!endpoint) return;
  const key = 'shappa.creator.referral.v1';
  const root = window.Shopify?.routes?.root || '/';
  let saved = null;
  try { saved = JSON.parse(localStorage.getItem(key) || 'null'); } catch (_) {}
  async function syncCart(token) {
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({attributes: {shappa_referral__: token || ''}})
    });
    if (!response.ok) throw new Error('Referral could not be saved to this cart.');
  }
  const ready = (async () => {
    const code = new URL(location.href).searchParams.get('ref');
    if (code && /^SHAPPA-[A-F0-9]{10}$/.test(code)) {
      try {
        const response = await fetch(endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({code})});
        if (response.ok) {
          const value = await response.json();
          if (typeof value.token === 'string' && Number.isFinite(value.expires_at)) {
            saved = value;
            try { localStorage.setItem(key, JSON.stringify(saved)); } catch (_) {}
          }
        }
      } catch (_) { /* Retain the last valid referral if the new lookup fails. */ }
    }
    if (saved && saved.expires_at <= Date.now()/1000) {
      saved = null;
      try { localStorage.removeItem(key); } catch (_) {}
      await syncCart('');
    } else if (saved) await syncCart(saved.token);
  })();
  // Expose a promise for theme checkout controls. No customer data is exposed.
  window.shappaReferralReady = ready.catch(() => false);
})();
